import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=5c2574ea&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=5c2574ea&prod&lang=css&"
import style1 from "./Chat.vue?vue&type=style&index=1&id=5c2574ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2574ea",
  null
  
)

export default component.exports